export default "__VITE_ASSET__EJ4lofk2__"